<template>
  <!-- 重点客户 -->
  <div class="partner">
    <p style="padding: 5px;">请上传重点客户LOGO,最多20张</p>
    <el-upload action="#" 
    :limit="20" 
    :file-list="fileList" 
    list-type="picture-card" 
    :http-request="uploadfile" 
    :multiple='false' 
    :before-upload="beforeAvatarUpload"
    :auto-upload="true">
      <i slot="default" class="el-icon-plus"></i>
      <div slot="file" slot-scope="{file}">
        <img class="el-upload-list__item-thumbnail" :src="file.pictures" alt="">
        <span class="el-upload-list__item-actions">
          <span class="el-upload-list__item-preview" @click="view(file)">
            <i class="el-icon-zoom-in"></i>
          </span>
          <span v-if="!disabled" class="el-upload-list__item-delete" @click="handleDownload(file)">
            <i class="el-icon-download"></i>
          </span>
          <span v-if="!disabled" class="el-upload-list__item-delete" @click="handleRemove(file)">
            <i class="el-icon-delete"></i>
          </span>
        </span>
      </div>
    </el-upload>

    <el-dialog v-dialogDrag :visible.sync="dialogVisible">
      <img style=" width: 100%;;height: 36rem" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>

</template>

<script>
import api from '@/apis/sale/sale'
import upapi from '@/apis/upload'
export default {
  data() {
    return {
      dialogImageUrl: '',
      dialogVisible: false,
      disabled: false,
      fileList: [
        // {
        //   name: 'food.jpeg',
        //   url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100',
        // },
      ],
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    getList(){
          api
      .getPartner()
      .then((res) => {
        if (res.code === 10000) {
          if (res.data.list.length) {
            this.fileList = res.data.list
          }
        } else {
          this.$message.error(res.message)
        }
      })
    },
    handleRemove(file) {
      return this.$confirm(`确定移除此图片？`).then(() => {
        this.fileList.map((item, index) => {
          if (item.id == file.id) {
            // 删除
            api.delPartner([file.id]).then((res) => {
              if (res.code === 10000) {
                this.getlist()
                this.$message.success(res.message)
              } else {
                this.$message.error(res.message)
              }
            })
            this.fileList.splice(index, 1)
            upapi.del({ params: { filePath: file.pictures } }).then(
            //   (res) => {
            //   if (res.code == 10000) {
            //     //  this.$message.success(res.message)
            //     
            //   } else {
            //     this.$message.error(res.message)
            //   }
            // }
            )
          }
        })
      })
    },
    view(file) {
      this.dialogImageUrl = file.pictures
      this.dialogVisible = true
    },
    //下载
    handleDownload(file) {
      open(file.pictures)
    },
    save() {
      // this.fileList = []
      api.savePartner(this.fileList).then((res) => {
        if (res.code === 10000) {
          this.getList()
          this.$message.success(res.message)
        } else {
          this.$message.error(res.message)
        }
      })
    },
    //上传图片
    uploadfile(val) {
      let fd = new FormData()
      fd.append('file', val.file)
      upapi.upload(fd).then((res) => {
        if (res.code == 10000) {
          // this.$message.success(res.message)

          this.fileList.push({
            pictures: res.data,
            url: res.data,
            uid: val.file.uid,
          })
          this.save()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    //判断上传文件格式是否合法
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    },
  },
}
</script>

<style lang="less">
.partner {
  .el-upload--picture-card {
    background-color: #00a1ff38;
  }

  .el-upload-list li {
    width: 16rem !important;
    height: 11rem !important; margin: 10px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .el-upload-list__item{ border-radius: 0;}
  .el-upload--picture-card {
    font-size: 2rem !important;
    width: 16rem !important;
    height: 11rem !important; margin: 10px;
    line-height:11rem !important;
    text-align: center; border: #555e86 dashed 1px; border-radius: 0;
      i{ font-size: 2rem;}
  }
  .el-icon-plus{ font-size: 2rem; color: #fff;}
}
</style>